import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {UsersComponent} from './pages/amaia/users/users.component';
import {HomeComponent} from './pages/home/home.component';
import {EditUserComponent} from './pages/amaia/edit-user/edit-user.component';
import {RolesComponent} from './pages/amaia/roles/roles.component';
import {PermissionsComponent} from './pages/amaia/permissions/permissions.component';
import {PostsComponent} from './pages/idontcare/posts/posts.component';


const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'amaia/users', component: UsersComponent},
    {path: 'amaia/users/edit/:name', component: EditUserComponent},
    {path: 'amaia/roles', component: RolesComponent},
    {path: 'amaia/permissions', component: PermissionsComponent},
    {path: 'idc/posts', component: PostsComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
